/**
 * Scripts pour la mise à jour trans-fenêtres/trans-onglets du Bouton du Panier.
 */

import { pipe } from "@mobily/ts-belt";

import type { MessageMajBoutonPanier } from "./lib/types/messages";

import { ATTRIBUT_CONTIENT_ARTICLES, SELECTEUR_BOUTON_PANIER } from "./constantes/dom.ts";
import { NOM_CANAL_BOUTON_PANIER } from "./constantes/messages.ts";
import { recupereElementOuLeve } from "./lib/dom.ts";
import { valideMessageMajBoutonPanier } from "./lib/messages.ts";
import { recupereElementDocumentEither } from "./lib/utils.ts";

const initialiseBoutonPanier = (): void => {
  /** Le « Bouton » vers le Panier dont le texte est un indicateur du nombre de Produits dedans. */
  const BOUTON_PANIER: HTMLAnchorElement = pipe(
    recupereElementDocumentEither<HTMLAnchorElement>(SELECTEUR_BOUTON_PANIER),
    recupereElementOuLeve,
  );
  const CANAL_BOUTON_PANIER: BroadcastChannel = new BroadcastChannel(NOM_CANAL_BOUTON_PANIER);

  CANAL_BOUTON_PANIER.onmessage = (evenementMessage: MessageEvent<unknown>): void => {
    valideMessageMajBoutonPanier(evenementMessage)
      // Met à jour le Bouton du Panier
      .ifRight((message: MessageMajBoutonPanier) => {
        BOUTON_PANIER.textContent = `cart (${String(message.donnees.quantiteProduits)})`;
        BOUTON_PANIER.setAttribute(ATTRIBUT_CONTIENT_ARTICLES, String(message.donnees.quantiteProduits > 0));
      });
  };

  // Ferme le BroadcastChannel à la fermeture de la page
  document.addEventListener("visibilitychange", (): void => {
    CANAL_BOUTON_PANIER.close();
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initialiseBoutonPanier();
});
